export default __webpack_public_path__ + "static/media/Nik.5f85e1b4.png";